import axios from "axios";
import { apiEndpoint } from "../config";
import refreshInterceptor from "./refreshInterceptor/refreshInterceptor";

const NftMyCollectionAPI = axios.create({
  baseURL: apiEndpoint.nftMyCollection,
  headers: {
    "content-type": "application/json",
  },
});
NftMyCollectionAPI.interceptors.request.use(refreshInterceptor);

export default NftMyCollectionAPI;
